/**
 * @class PaymentTypePipe
 *
 * @author Leonardo Pliskieviski
 */

import { Pipe, PipeTransform } from '@angular/core';
import { ContractPaymentType } from '@app/core/models/contract/contract.model';

@Pipe({
  name: 'paymentType',
})
export class PaymentTypePipe implements PipeTransform {
  private readonly PRESENTABLE_PAYMENT_TYPE_NAMES = {
    [ContractPaymentType.DEBIT]: 'Débito',
    [ContractPaymentType.CREDIT_CARD]: 'Cartão de crédito',
    [ContractPaymentType.PAYROLL_DISCOUNT]: 'Desconto em folha',
  };

  transform(paymentType: ContractPaymentType): string {
    return this.PRESENTABLE_PAYMENT_TYPE_NAMES[paymentType];
  }
}
